// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"69":"5e740acd","526":"9f3cc61d"}[chunkId] + ".chunk.js";
};